import { motion } from 'framer-motion';

interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  color: 'accent' | 'orange' | 'xp' | 'green';
  sub?: string;
}

const colorMap = {
  accent: { bg: 'bg-xd-info/10 text-xd-info', border: 'border-l-xd-info' },
  orange: {
    bg: 'bg-xd-action-end/10 text-xd-action-end',
    border: 'border-l-xd-action-end',
  },
  xp: { bg: 'bg-xd-xp/10 text-xd-xp', border: 'border-l-xd-xp' },
  green: { bg: 'bg-xd-action/10 text-xd-action', border: 'border-l-xd-action' },
};

export function StatCard({ icon, label, value, color, sub }: StatCardProps) {
  const colors = colorMap[color];
  return (
    <motion.div
      whileHover={{ y: -2 }}
      transition={{ duration: 0.2 }}
      className={`card-hover rounded-2xl border border-border border-l-4 ${colors.border} bg-surface p-5 shadow-soft`}
    >
      <div className="flex items-center gap-3">
        <div className={`rounded-lg p-2 ${colors.bg}`}>{icon}</div>
        <div className="min-w-0 flex-1">
          <p className="text-xs font-medium uppercase tracking-wider text-text-muted">{label}</p>
          <p className="text-2xl font-bold text-text">{value}</p>
          {sub && <p className="text-xs text-text-muted mt-1">{sub}</p>}
        </div>
      </div>
    </motion.div>
  );
}
